const ArrowRightPagination = ({ size = 24, fill = '#FFFEFE', viewBox = '0 0 7 12' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.666748 11.8719V0.128418L6.53848 6.00015L0.666748 11.8719Z" fill={fill} />
    </svg>
  );
};

export default ArrowRightPagination;
